import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/BekoBeyazEsya.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const BekoBeyazEsya = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  
    const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

  useEffect(() => {
    // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);

        const closeDetail = () => {
    setIsDetailOpen(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

    // Ürün bilgileri
  const products = {
    '970477MB': {
      name: '970477 MB No Frost Buzdolabı',
      image: '../files/970477MB.webp',
      description: 'Ezberleri bozan yeni AeroFlow Soğutma Teknolojisi rafların üzerine doğrudan üfleme yapmaz, tazeliği dolabın tamamına yayar. Yiyecekler %30\'a kadar daha uzun süre taze kalır.',
      features: [
        'AeroFlow Soğutma Teknolojisi',
        '%30\'a kadar daha uzun tazelik',
        'Kapı yönü esnekliği (sağ/sol)',
        'Intertek test onaylı tazelik',
        'No Frost Teknoloji',
        'Geniş Hacim',
      ],
      dimensions: 'G: 70 cm, D: 75 cm, Y: 187 cm',
      warranty: '3 Yıl Garanti',
      price: "31.499,00 ₺'den başlayan fiyatlarla",
    },
    '670475MB': {
      name: '670475 MB No Frost Buzdolabı',
      image: '../files/670475MB.jpg',
      description: 'AeroFlow Soğutma Teknolojisi: Rafların üzerinde doğrudan üfleyerek değil, dolabın tamamına eşit hava dağıtarak yiyeceklerin %30 daha uzun süre taze kalmasını sağlar. Akıllı sensörler ve antibakteriyel iç yüzey ile gıdalarınız hem daha sağlıklı hem de daha uzun ömürlü saklanır. Kapı yönü esnekliği sayesinde kullanım alanınıza göre sağa veya sola açılacak şekilde ayarlanabilir.',
      features: [
        'AeroFlow Soğutma Teknolojisi (eşit hava dağılımı)',
        '%30 daha uzun tazelik',
        'Akıllı sensörler ile optimal soğutma',
        'Antibakteriyel iç yüzey',
        'Kapı yönü esnekliği (sağ/sol)',
        'No Frost Teknoloji',
      ],
      dimensions: 'G: 70 cm, D: 75 cm, Y: 187 cm',
      warranty: '3 Yıl Garanti',
      price: "35.999,00 ₺'den başlayan fiyatlarla",
    },
    '678550EI-Fit': {
      name: '678550 EI ElegantFit No Frost Buzdolabı',
      image: '../files/678550EIFit.webp',
      description: 'ElegantFit Teknolojisi ile fit yerleşim, mutfağınıza tam uyum ve içeride maksimum hacim sunar. Fit tasarımı sayesinde buzdolabı, sağdan ve soldan 5’er cm yerine yalnızca 0,3 cm boşlukla mutfak dolabınıza mükemmel şekilde yerleşir. HarvestFresh™ 3 ışık teknolojisi ile buzdolabınızda 24 saatlik doğal gün ışığı döngüsü simüle edilir, meyve ve sebzelerin vitamin değerleri daha uzun süre korunur ve ilk günkü gibi taze kalır. Testler bağımsız laboratuvarlarda, farklı sebze-meyve grupları için Vitamin A ve C seviyeleri ölçülerek ve depolama öncesi değerlerle kıyaslanarak gerçekleştirilmiştir. Kapı alt ve üstlerinde bulunan menteşe yerleri değiştirilerek kapıların kapanma yönleri sağa veya sola kapanacak şekilde ayarlanabilir.',
      price: "60.269,00 ₺'den başlayan fiyatlarla",
      features: [
        'ElegantFit Teknolojisi (fit yerleşim)',
        'HarvestFresh™ 3 ışık teknolojisi',
        'Vitamin koruma ve tazelik',
        'Kapı yönü esnekliği (sağ/sol)',
        'Maksimum iç hacim',
        'LED aydınlatma',
        'No Frost Teknoloji',
      ],
      dimensions: 'G: 78 cm, D: 76 cm, Y: 188 cm',
      warranty: '3 Yıl Garanti',
    },
    'Cmx10120': {
      name: 'Cmx 10120 Çamaşır Makinesi',
      image: '../files/Cmx10120.webp',
      description: "10 Kg Çamaşır Makinesi. Makine çalıştırıldıktan sonra unutulan çamaşırların ilave edilebilmesini sağlar, kapağın komple açılabilmesi büyük çamaşırların da atılabilmesine olanak verir. Yıkama yapmadan buharlı havalandırma teknolojisi sayesinde kıyafetlerinizdeki kötü kokuları azaltır. Buharlı havalandırma programı pamuklu, sentetik ve karışık kumaş türlerinde kullanılabilir, 17dk boyunca havalandırarak kıyafetlerinizin ferah kokmalarını sağlar. Kazan Temizleme Teknolojisi, çamaşır makinesi içerisindeki hijyeni sağlayarak kazanı temizler ve kötü koku oluşumunu engeller. Prosmart Inverter motor sayesinde makinenin ömrü uzarken enerji tasarrufu da sağlanmış olur. Aynı zamanda makineniz daha sessiz ve verimli çalışır. Çamaşır makinesi tamburunun yaklaşık %10'u geri dönüştürülmüş pet şişelerden oluşmuştur.",
      price: "32.249,00 ₺'den başlayan fiyatlarla",
      features: [
        '10 kg kapasite',
        'Unutulan çamaşır ekleme',
        'Tam açılabilen kapak',
        'Buharlı havalandırma teknolojisi',
        'Kazan Temizleme Teknolojisi',
        'Sessiz ve verimli çalışma',
        'Tamburda %10 geri dönüştürülmüş PET'
      ],
      dimensions: 'G: 60 cm, D: 58 cm, Y: 85 cm',
      warranty: '3 Yıl Garanti',
    },
    'Cmxt9120': {
      name: 'Cmxt 9120 Çamaşır Makinesi',
      image: '../files/Cmxt9120.webp',
      description: "Makine çalıştırıldıktan sonra unutulan çamaşırların ilave edilebilmesini sağlar, kapağın komple açılabilmesi büyük çamaşırların da atılabilmesine olanak verir. Yıkama yapmadan buharlı havalandırma teknolojisi sayesinde kıyafetlerinizdeki kötü kokuları azaltır! Buharlı havalandırma programı pamuklu, sentetik ve karışık kumaş türlerinde kullanılabilir, 17dk boyunca havalandırarak kıyafetlerinizin ferah kokmalarını sağlar. Kazan Temizleme Teknolojisi, çamaşır makinesi içerisindeki hijyeni sağlayarak kazanı temizler ve kötü koku oluşumunu engeller. Prosmart Inverter motor sayesinde makinenin ömrü uzarken enerji tasarrufu da sağlanmış olur. Aynı zamanda makineniz daha sessiz ve verimli çalışır. Çamaşır makinesi tamburunun yaklaşık %10'u geri dönüştürülmüş pet şişelerden oluşmuştur.",
      price: "26.399,00 ₺'den başlayan fiyatlarla",
      features: [
        '9 kg kapasite',
        'Unutulan çamaşır ekleme',
        'Tam açılabilen kapak',
        'Buharlı havalandırma teknolojisi',
        'Kazan Temizleme Teknolojisi',
        'Sessiz ve verimli çalışma',
        'Tamburda %10 geri dönüştürülmüş PET',
        ],
        dimensions: 'G: 60 cm, D: 55 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'Cmxd9100': {
      name: 'Cmxd 9100 Çamaşır Makinesi',
      image: '../files/Cmxd9100.webp',
      description: "Makine çalıştırıldıktan sonra unutulan çamaşırların ilave edilebilmesini sağlar, kapağın komple açılabilmesi büyük çamaşırların da atılabilmesine olanak verir. Yıkama yapmadan buharlı havalandırma teknolojisi sayesinde kıyafetlerinizdeki kötü kokuları azaltır! Buharlı havalandırma programı pamuklu, sentetik ve karışık kumaş türlerinde kullanılabilir, 17dk boyunca havalandırarak kıyafetlerinizin ferah kokmalarını sağlar. Kazan Temizleme Teknolojisi, çamaşır makinesi içerisindeki hijyeni sağlayarak kazanı temizler ve kötü koku oluşumunu engeller. Prosmart Inverter motor sayesinde makinenin ömrü uzarken enerji tasarrufu da sağlanmış olur. Aynı zamanda makineniz daha sessiz ve verimli çalışır. Çamaşır makinesi tamburunun yaklaşık %10'u geri dönüştürülmüş pet şişelerden oluşmuştur.",
      price: "30.299,00 ₺'den başlayan fiyatlarla",
      features: [
        '9 kg kapasite',
        'Unutulan çamaşır ekleme',
        'Tam açılabilen kapak',
        'Buharlı havalandırma teknolojisi',
        'Kazan Temizleme Teknolojisi',
        'Sessiz ve verimli çalışma',
        'Tamburda %10 geri dönüştürülmüş PET',
        ],
        dimensions: 'G: 60 cm, D: 58 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'BM6146': {
      name: 'BM 6146 Bulaşık Makinesi',
      image: '../files/BM6146.webp',
      description: "6 Programlı Bulaşık Makinesi. Otomatik Kapı Açma Özelliği: Beko'dan bulaşıklarınızı düşünen teknoloji. Beko bulaşık makinelerinin kapısı yıkama bitince otomatik olarak açılır. Doğal hava akışı ile bulaşıklar 5 kata kadar daha iyi kurur. Yüksek sıcaklık etkisi ile oluşan Buhar ve ekstra sıcak durulamanın gücüyle HijyenMax teknolojisi bulaşıkların her noktasında hijyen sağlar. Programın sonunda gerçekleşen ekstra kurutma ve buhar uygulaması sayesinde bulaşıkların üzerinde kalan su damlalarının küçülmesini ve yok olmasını sağlar. Bu sayede daha parlak cam ve porselenlere sahip olmanıza yardımcı olur.",
      price: "23.129,00 ₺'den başlayan fiyatlarla",
      features: [
        '6 program',
        'Otomatik kapı açma',
        'HijyenMax teknolojisi',
        'Ekstra kurutma ve buhar',
        'Daha parlak cam ve porselen',
        'Doğal hava akışı ile kurutma',
        ],
        dimensions: 'G: 60 cm, D: 60 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'BM4144WF': {
      name: 'BM 4144 WF Bulaşık Makinesi',
      image: '../files/BM4144WF.webp',
      description: "4 Programlı Bulaşık Makinesi. 4 Program + 3 İndirilebilir Program. HomeWhiz Teknolojisi ile evdeki akıllı beyaz eşyalarınızı Wi-Fi aracılığıyla internete erişebildiğiniz her yerden kontrol etmek çok kolay! Akıllı cep telefonu veya tabletlerinizden Kablosuz Ağ Bağlantısı olan beyaz eşyalarınızı Homewhiz uygulamanız üzerinden çalıştırmanız ve güncel durumları hakkında bilgi sahibi olmanız mümkün. Yüksek sıcaklık etkisi ile oluşan Buhar ve ekstra sıcak durulamanın gücüyle HijyenMax teknolojisi bulaşıkların her noktasında hijyen sağlar. Programın sonunda gerçekleşen ekstra kurutma ve buhar uygulaması sayesinde bulaşıkların üzerinde kalan su damlalarının küçülmesini ve yok olmasını sağlar. Bu sayede daha parlak cam ve porselenlere sahip olmanıza yardımcı olur.",
      price: "22.859,00 ₺'den başlayan fiyatlarla",
      features: [
        '4 program',
        '3 indirilebilir program',
        'HomeWhiz Wi-Fi teknolojisi',
        'HijyenMax teknolojisi',
        'Ekstra kurutma ve buhar',
        'Daha parlak cam ve porselen',
        'Doğal hava akışı ile kurutma',
        ],
        dimensions: 'G: 60 cm, D: 60 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'BM4144OKI': {
      name: 'BM 4144 OK I Bulaşık Makinesi',
      image: '../files/BM4144OKI.webp',
      description: "Beko'dan 4 Programlı bulaşıklarınızı düşünen teknolojik bulaşık makinesi. Beko bulaşık makinelerinin kapısı yıkama bitince otomatik olarak açılır. Doğal hava akışı ile bulaşıklar 5 kata kadar daha iyi kurur. Bağımsız 3. parti laboratuvar tarafından Mini 30 programında, kapı açık ve kapalı senaryoları ile yapılan testlerde, otomatik kapı açma teknolojisi ile 5 kata kadar daha yüksek kurutma performansı ölçülmüştür. Kullanım koşullarına göre değişebilir. Yüksek sıcaklık etkisi ile oluşan Buhar ve ekstra sıcak durulamanın gücüyle HijyenMax teknolojisi bulaşıkların her noktasında hijyen sağlar. Programın sonunda gerçekleşen ekstra kurutma ve buhar uygulaması sayesinde bulaşıkların üzerinde kalan su damlalarının küçülmesini ve yok olmasını sağlar. Bu sayede daha parlak cam ve porselenlere sahip olmanıza yardımcı olur.",
      price: "25.019,00 ₺'den başlayan fiyatlarla",
      features: [
        '4 program',
        'Otomatik kapı açma',
        'HijyenMax teknolojisi',
        'Ekstra kurutma ve buhar',
        'Daha parlak cam ve porselen',
        'Doğal hava akışı ile kurutma',
        ],
        dimensions: 'G: 60 cm, D: 60 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'KMX91': {
      name: 'KMX 91 Kurutma Makinesi',
      image: '../files/KMX91.webp',
      description: "9 Kg Kurutma Makinesi. Isı pompalı kurutma teknolojisi, geleneksel kondenserli kurutma makinelerine göre kıyafetlerinizi daha verimli ve renklerini koruyarak kurutur. Akıllı Nem Sensörü: Kuruluk seviyesini algılayarak, kurutma süresini istenilen kuruluk derecesine göre hesaplar ve otomatik olarak ayarlar, böylece az kapasite çamaşır kuruturken daha az enerji harcar. Size en havalı kıyafetler yakışır! Yıkanmaya ihtiyacı olmayan ama kötü kokulardan arınması gereken kıyafetleriniz için en ideal program karşınızda!",
      price: "30.869,00 ₺'den başlayan fiyatlarla",
      features: [
        '9 kg kapasite',
        'Isı pompalı kurutma teknolojisi',
        'Akıllı nem sensörü',
        'Enerji tasarrufu',
        'Koku giderici program',
        ],
        dimensions: 'G: 60 cm, D: 61 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'KMB901I': {
      name: 'KMB 901 I Kurutma Makinesi',
      image: '../files/KMB901I.webp',
      description: "Kuruluk seviyesini algılayarak, kurutma süresini istenilen kuruluk derecesine göre hesaplar ve otomatik olarak ayarlar, böylece az kapasite çamaşır kuruturken daha az enerji harcar. 3 farklı koku seçeneğiyle, kurutma işlemi yapılırken çamaşırlarınıza seçtiğiniz kokuyu verir. Mis gibi kokan kup kuru çamaşırlara sahip olursunuz. Isı pompalı kurutma teknolojisi, geleneksel kondenserli kurutma makinelerine göre kıyafetlerinizi daha verimli ve renklerini koruyarak kurutur.",
      price: "33.179,00 ₺'den başlayan fiyatlarla",
      features: [
        '9 kg kapasite',
        'Isı pompalı kurutma teknolojisi',
        'Akıllı nem sensörü',
        'Enerji tasarrufu',
        '3 farklı koku seçeneği',
        'Koku giderici program',
        ],
        dimensions: 'G: 60 cm, D: 61 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'KMX1001': {
      name: 'KMX 1001 Kurutma Makinesi',
      image: '../files/KMX1001.webp',
      description: "Size en havalı kıyafetler yakışır! Yıkanmaya ihtiyacı olmayan ama kötü kokulardan arınması gereken kıyafetleriniz için en ideal program karşınızda! Kuruluk seviyesini algılayarak, kurutma süresini istenilen kuruluk derecesine göre hesaplar ve otomatik olarak ayarlar, böylece az kapasite çamaşır kuruturken daha az enerji harcar. Isı pompalı kurutma teknolojisi, geleneksel kondenserli kurutma makinelerine göre kıyafetlerinizi daha verimli ve renklerini koruyarak kurutur.",
      price: "33.509,00 ₺'den başlayan fiyatlarla",
      features: [
        '10 kg kapasite',
        'Isı pompalı kurutma teknolojisi',
        'Akıllı nem sensörü',
        'Enerji tasarrufu',
        'Koku giderici program',
        ],
        dimensions: 'G: 60 cm, D: 61 cm, Y: 85 cm',
        warranty: '3 Yıl Garanti',
    },
    'B50E795B': {
      name: 'Crystal 7 50" 4K UHD Google TV - B50 E 795 B Smart TV',
      image: '../files/B50E795B.webp',
      description: "İzlemek istedikleriniz, tek bir yerde. Google TV; Netflix, YouTube, Disney+, Amazon Prime ve daha fazlasını tek bir ekranda bir araya getirir. Tüm favori uygulamalarınızı tek platformda keşfedin. FHD TV’den 4 kat daha fazla piksele sahip olan 4K UHD TV ile her sahnedeki en küçük ayrıntıları bile görebilirsiniz. Beko TV’lerdeki HDR 10+ teknolojisi ile görüntüdeki ışık seviyesi analiz edilir; en parlak ve en karanlık kısımlarını olduğundan daha koyu ya da olduğundan daha parlak görmemizi sağlar. HDR10+ teknolojisi, standart HDR10’a göre sahnelerde daha gelişmiş iyileştirmeler sunmaktadır. Televizyon panellerinde görülebilen parlak beyaz pikseller keyfinizi bozmasın! Beko TV'ler kusursuz seyir keyfini garanti ediyor. Parlak piksel hatası ile karşılaşılması durumunda televizyonunuzu anında yenisi ile değiştiriyoruz. Dinamik bir HDR formatı olan Dolby Vision, bu formatı destekleyen içeriklerdeki her bir sahneyi daha kaliteli bir görüntü deneyimi için optimize etmektedir. En parlak ve en karanlık noktalar arasındaki derinliği ortaya çıkararak daha fazla detay görmenizi sağlamaktadır. Chromecast Built-in ile Kolay Ekran Yansıtma! Mobil cihazlardaki veya dizüstü bilgisayarlardaki favori içeriklerinizi kolayca büyük ekran Beko TV'nize yansıtın. Beko TV deneyiminizi Kolaylaştırın! Telefonunuza indireceğiniz uygulama ile tv'nizi rahatlıkla kontrol edebilirsiniz. Favori kanal listenizi oluşturun, touchpad ve telefon klavyesiyle internette kolayca gezinin!",
      price: "28.999,00 ₺'den başlayan fiyatlarla",
      features: [
        '4K Ultra HD',
        'Google TV',
        'HDR10+ ve Dolby Vision',
        'Parlak piksel garantisi',
        'Chromecast Built-in',
        'Kolay mobil kontrol',
        'Gelişmiş panel teknolojisi',
      ],
      dimensions: 'G: 112 cm, D: 29 cm, Y: 71 cm',
      warranty: '3 Yıl Garanti',
    },
    'B55E795B': {
      name: 'Crystal 7 55" 4K UHD Google TV - B55 E 795 B LED TV',
      image: '../files/B55E795B.webp',
      description: "İzlemek istedikleriniz, tek bir yerde. Google TV; Netflix, YouTube, Disney+, Amazon Prime ve daha fazlasını tek bir ekranda bir araya getirir. Tüm favori uygulamalarınızı tek platformda keşfedin. FHD TV’den 4 kat daha fazla piksele sahip olan 4K UHD TV ile her sahnedeki en küçük ayrıntıları bile görebilirsiniz. Beko TV’lerdeki HDR 10+ teknolojisi ile görüntüdeki ışık seviyesi analiz edilir; en parlak ve en karanlık kısımlarını olduğundan daha koyu ya da olduğundan daha parlak görmemizi sağlar. HDR10+ teknolojisi, standart HDR10’a göre sahnelerde daha gelişmiş iyileştirmeler sunmaktadır. Televizyon panellerinde görülebilen parlak beyaz pikseller keyfinizi bozmasın! Beko TV'ler kusursuz seyir keyfini garanti ediyor. Parlak piksel hatası ile karşılaşılması durumunda televizyonunuzu anında yenisi ile değiştiriyoruz. Dinamik bir HDR formatı olan Dolby Vision, bu formatı destekleyen içeriklerdeki her bir sahneyi daha kaliteli bir görüntü deneyimi için optimize etmektedir. En parlak ve en karanlık noktalar arasındaki derinliği ortaya çıkararak daha fazla detay görmenizi sağlamaktadır. Chromecast Built-in ile Kolay Ekran Yansıtma! Mobil cihazlardaki veya dizüstü bilgisayarlardaki favori içeriklerinizi kolayca büyük ekran Beko TV'nize yansıtın. Beko TV deneyiminizi Kolaylaştırın! Telefonunuza indireceğiniz uygulama ile tv'nizi rahatlıkla kontrol edebilirsiniz. Favori kanal listenizi oluşturun, touchpad ve telefon klavyesiyle internette kolayca gezinin!",
      price: "31.999,00 ₺'den başlayan fiyatlarla",
      features: [
        '4K Ultra HD',
        'Google TV',
        'HDR10+ ve Dolby Vision',
        'Parlak piksel garantisi',
        'Chromecast Built-in',
        'Kolay mobil kontrol',
        'Gelişmiş panel teknolojisi',
      ],
      dimensions: 'G: 113 cm, D: 29 cm, Y: 77 cm',
      warranty: '3 Yıl Garanti',
    },
    'B65E795B': {
      name: 'Crystal 7 65" 4K UHD Google TV - B65 E 795 B LED TV',
      image: '../files/B65E795B.webp',
      description: "FHD TV’den 4 kat daha fazla piksele sahip olan 4K UHD TV ile her sahnedeki en küçük ayrıntıları bile görebilirsiniz. İzlemek istedikleriniz, tek bir yerde. Google TV; Netflix, YouTube, Disney+, Amazon Prime ve daha fazlasını tek bir ekranda bir araya getirir. Tüm favori uygulamalarınızı tek platformda keşfedin. Televizyon panellerinde görülebilen parlak beyaz pikseller keyfinizi bozmasın! Beko TV'ler kusursuz seyir keyfini garanti ediyor. Parlak piksel hatası ile karşılaşılması durumunda televizyonunuzu anında yenisi ile değiştiriyoruz. Beko TV’lerdeki HDR 10+ teknolojisi ile görüntüdeki ışık seviyesi analiz edilir; en parlak ve en karanlık kısımlarını olduğundan daha koyu ya da olduğundan daha parlak görmemizi sağlar. HDR10+ teknolojisi, standart HDR10’a göre sahnelerde daha gelişmiş iyileştirmeler sunmaktadır. Eğlenceli Beko Akıllı TV dünyasına adım atın! Beko Smart TV ile zengin içeriklerle dolu birbirinden keyifli ve popüler uygulamalara, istediğiniz zaman, kolayca erişin.",
      price: "43.999,00 ₺'den başlayan fiyatlarla",
      features: [
        '4K Ultra HD',
        'Google TV',
        'HDR10+ ve Dolby Vision',
        'Parlak piksel garantisi',
        'Chromecast Built-in',
        'Kolay mobil kontrol',
        'Gelişmiş panel teknolojisi',
        'Beko Smart TV',
      ],
      dimensions: 'G: 145 cm, D: 32 cm, Y: 91 cm',
      warranty: '3 Yıl Garanti',
    },
    'BOCDT6510EG': {
      name: 'BOCD T 6510 EG Beyond Serisi Gazlı Cam Tablalı Ocak',
      image: '../files/BOCDT6510EG.webp',
      description: "Özel Nano Kaplama Teknolojisine sahip PractiClean Beko cam ocakların yüzeyi 18 kat daha az su ve deterjanla temizlenir. Parmak izleri bile kolayca silinir. Cam yüzeyde pişirme sonrası oluşan lekeler iz bırakmadan hızlı ve kolayca temizlenirken ocak yüzeyi parlaklığını korur. *Bağımsız kuruluş tarafından; Demi glace sos ile kirlendirilen Beko'ya ait kaplamalı ve kaplamasız cam yüzeyler, nemli ve 0.1gr deterjan içeren süngerler ile temizlenerek karşılaştırma yapılmıştır. Beko XL ankastre ocaklarla 4 yemeği aynı anda, rahatlıkla pişirmek artık mümkün. Pişirme gözleri arasındaki mesafenin genişletildiği ankastre ocak ile büyük tencerelerinizi yan yana rahatlıkla kullanın, mutfağınızda her anın tadını çıkarın. 28,26,24 ve 22 cm genişliğinde tencerelerle tek seferde 2 kata kadar daha fazla yemek pişirebilirsiniz. Üstelik 60 cm ocaklarla aynı boşluğa yerleştirilebilir. Verimli Ocak Gözleri - Ortalamada %63'e kadar daha verimli çalışan ocak gözleri ile yemeklerinizi daha hızlı pişirebilirsiniz. Yüksek verimli ocak gözleri sayesinde enerjiden tasarruf ederken mutfakta geçirdiğiniz zaman daha keyifli hale gelir.",
      price: "12.780,00 ₺'den başlayan fiyatlarla",
      features: [
        'PractiClean Nano Kaplama',
        '18 kat daha az su ve deterjanla temizlik',
        'XL ankastre ocak (4 yemek aynı anda)',
        'Geniş pişirme gözleri',
        'Verimli ocak gözleri (%63 daha hızlı)',
        'Kolay temizlik ve parlaklık',
        '60 cm boşluğa yerleşim',
      ],
      dimensions: 'G: 65 cm, D: 52 cm, Y: 5 cm',
      warranty: '3 Yıl Garanti',
    },
    'BFC432G': {
      name: 'BFC 432 G FitFry Fırın',
      image: '../files/BFC432G.webp',
      description: "FitFry Teknolojili ve Buhar Destekli 2’si Bir Arada Ankastre Fırın. Beko ankastre fırınların yenilenen fan sistemi ve iç tasarımı sayesinde sıcak hava fırınınızın içerisinde kusursuz şekilde dağılır. Kusursuz dağılan hava %40 daha homojen pişirme sağlarken, her pişirmede aynı sonucu almanızı sağlar. Beko fırınlarda en son teknolojiler bir arada! Yeni nesil 3D Pişirme teknolojisi fırındaki alt, üst ve turbo ısıtıcıları aynı anda çalıştırarak ısıyı eşit bir yoğunlukla dağıtır. Bu sayede yemeklerin tüm yüzeylerine ısı dengeli bir şekilde dağılır ve ideal pişirme gerçekleşir. 3D Pişirme teknolojisiyle yemekleriniz yanmadan, eşit bir şekilde pişer. Beko fırınlarda bulunan katalitik yan duvarlar sayesinde fırın temizliği artık çok kolay! Yan yüzeylerde bulunan özel katalitik malzeme, görüntü kirliliğine ve kötü kokulara neden olan yağ artıklarını emer. Pişirme sırasında sıçrayan yağları düzenli olarak soğuran katalitik yan duvarlar sizi zahmetli bir fırın temizliğinden kurtarır, zamanınız size kalır. Temizlik fırından gelir! Buharlı temizleme özelliğini kullanarak fırının iç bölmesinde ulaşamadığınız veya zor temizlediğiniz bölümleri kolaylıkla temizleyebilirsiniz. Tek yapmanız gereken fırının tüm aksesuarlarını çıkardıktan sonra tepsiyi en alt seviyeye, içerisine bir miktar su koyarak yerleştirmek ve fonksiyon göstergesinde buharlı temizlemeyi seçmek. Çevrim bittiğinde fırınınızın içerisi kolaylıkla silinebilir bir hal alır. İşte bu kadar pratik!",
      price: "21.989,00 ₺'den başlayan fiyatlarla",
      features: [
        'FitFry Teknolojisi',
        'Buhar destekli pişirme',
        '3D Pişirme teknolojisi',
        'Katalitik yan duvarlar',
        'Buharlı temizleme',
        'Homojen sıcak hava dağılımı',
        'Kolay temizlik',
      ],
      dimensions: 'G: 59 cm, D: 57 cm, Y: 60 cm',
      warranty: '3 Yıl Garanti',
    },
    'BDE6062G': {
      name: 'BDE 6062 G Duvar Tipi Davlumbaz',
      image: '../files/BDE6062G.webp',
      description: "Yüksek emiş gücüne sahip Beko davlumbazlar buhar ve yemek kokularının kolayca ortadan kaldırılmasını sağlar. 3 ana kademeye ek 1 ekstra yoğun çekiş fonksiyonu ile yoğun ve ağır kokularda yüksek performans elde edilir. Beko Davlumbazlar düşük ses seviyesi ile görevini sessizce yaparak konfor sağlar. NTC sensör teknolojisi ile otomatik mod özelliğiyle ortamın ve ocaktan gelen havanın sıcaklığını ölçüp (panel üzerinde soldan ilk otomatik mod tuşuna basıldığında davlumbaz üzerinde bulunan 3 adet NTC sensörü ölçüm yaparak aktif hale gelir), sıcaklık artışına göre otomatik olarak kademesini ayarlar. Tabaklarınıza son dokunuşu yaptığınız anda NTC sensörler sıcaklığın azaldığını anlayıp davlumbazı otomatik olarak kapatır. Böylelikle davlumbaz daha verimli çalışarak daha az enerji harcar. Tek tuşla ayarlanabilir ışık şiddeti ve 3 farklı LED aydınlatma seçeneğiyle Sıcak Beyaz, Gün Işığı Parıltısı yada Soğuk beyaz gibi farklı stildeki ışıklardan dilediğinizi seçip mutfağınızı kendi tarzınızda aydınlatabilirsiniz. Hava temizleme fonksiyonu ile mutfaktaki havanın sürekli olarak tazelenmesi için davlumbaz düşük seviyede çalışır ve ortamda bulunan sigara dumanı vb gibi kötü kokuları temizler. Hız 1 tuşuna 3 saniye basıldığında mod devreye girer ve saatte 10 dakika çalışır. Mod kapatılmadığı taktirde 24 saat boyunca bu döngü devam eder. Hava temizleme modu etkinken lamba tuşu hariç herhangi bir tuşa basıldığında iptal olur.",
      price: "13.990,00 ₺'den başlayan fiyatlarla",
      features: [
        'Yüksek emiş gücü',
        'Ekstra yoğun çekiş fonksiyonu',
        'Düşük ses seviyesi',
        'NTC sensör teknolojisi',
        'Otomatik mod',
        'Ayarlanabilir LED aydınlatma',
        'Hava temizleme fonksiyonu',
      ],
      dimensions: 'G: 60 cm, D: 42 cm, Y: 114 cm',
      warranty: '3 Yıl Garanti',
    },
    '31225A': {
      name: '31225 A Ekolojik Inverter Klima 12.000 Btu/h Split Klima',
      image: '../files/31225A.png',
      description: "12000 Btu/h soğutma kapasitesi ile hızlı ve etkili iklimlendirme. Kolay çıkarılabilir özel filtreler sayesinde temizlik ve bakım çok pratik. Yumuşak hava modu ile ortamda homojen ve konforlu bir hava akışı sağlanır.",
      price: "32.655,00 ₺'den başlayan fiyatlarla",
      features: [
        '12000 Btu/h soğutma kapasitesi',
        'Kolay çıkarılabilir filtre',
        'Yumuşak hava modu',
        'Özel filtreler',
      ],
      dimensions: 'G: 84 cm, D: 19 cm, Y: 31 cm',
      warranty: '3 Yıl Garanti',
    },
    '31825': {
      name: '31825 Ekolojik Inverter Klima 18.000 Btu/h Split Klima',
      image: '../files/31225A.png',
      description: "18000 Btu/h soğutma kapasitesi ile hızlı ve etkili iklimlendirme. Kolay çıkarılabilir özel filtreler sayesinde temizlik ve bakım çok pratik. Yumuşak hava modu ile ortamda homojen ve konforlu bir hava akışı sağlanır.",
      price: "45.261,00 ₺'den başlayan fiyatlarla",
      features: [
        '18000 Btu/h soğutma kapasitesi',
        'Kolay çıkarılabilir filtre',
        'Yumuşak hava modu',
        'Özel filtreler',
      ],
      dimensions: 'G: 100 cm, D: 21 cm, Y: 35 cm',
      warranty: '3 Yıl Garanti',
    },
    '32425': {
      name: '32425 Ekolojik Inverter Klima 24.000 Btu/h Split Klima',
      image: '../files/31225A.png',
      description: "24000 Btu/h soğutma kapasitesi ile hızlı ve etkili iklimlendirme. Kolay çıkarılabilir özel filtreler sayesinde temizlik ve bakım çok pratik. Yumuşak hava modu ile ortamda homojen ve konforlu bir hava akışı sağlanır.",
      price: "53.802,00 ₺'den başlayan fiyatlarla",
      features: [
        '24000 Btu/h soğutma kapasitesi',
        'Kolay çıkarılabilir filtre',
        'Yumuşak hava modu',
        'Özel filtreler',
      ],
      dimensions: 'G: 100 cm, D: 21 cm, Y: 35 cm',
      warranty: '3 Yıl Garanti',
    },
    'CM5964': {
      name: 'CM 5964 Floral Çay Makinesi',
      image: '../files/CM5964.webp',
      description: "Demlik Kapasitesi 0.8 L, Demlik Malzemesi: Kırılmaya Karşı 4 Kata Kadar Dayanıklılığı Arttırılmış Cam. Su Isıtıcı Kapasitesi 2 L, Su Isıtıcı Malzemesi: Cam. Bir taşla iki kuş diye işte buna denir! Demlik kapağı aynı zamanda su ısıtıcı kapağı da olduğu için çay makinenizi kettle olarak da rahatlıkla kullanabilirsiniz. Kırılımaya karşı dayanıklılığı 4 kata arttırılmış cam demlik uzun yıllar mutfağınızın vazgeçilmezi olarak kalır. 2L geniş su haznesi ile uzun yıllar boyunca pratik yardımcınız olacak. Her şey hayatınızı kolaylıştırmak için tasarlandı. Mavi ışık çay suyunun sürekli sıcak olduğunu, kırmızı ışık ise suyun kaynamakta olduğunu gösterir.",
      price: "5.499,00 ₺'den başlayan fiyatlarla",
      features: [
        '0.8 L demlik kapasitesi',
        'Kırılmaya karşı 4 kata kadar dayanıklı cam demlik',
        '2 L su ısıtıcı kapasitesi',
        'Cam su ısıtıcı',
        'Demlik kapağı kettle kapağı olarak kullanılabilir',
        'Mavi ve kırmızı ışık göstergesi',
      ],
      dimensions: 'G: 24 cm, D: 17 cm, Y: 37 cm',
      warranty: '3 Yıl Garanti',
    },
    'TM5046C': {
      name: 'TM 5046 C Floral Tost Makinesi',
      image: '../files/TM5046C.webp',
      description: "Hiç bu kadar güçlü bir tost makinesi gördünüz mü? 2400 W gücüyle, aşınmaya karşı 7 kata kadar daha dayanıklı Quantech döküm plakalarıyla çok uzun ömürlüdür. 6 dilim kapasiteli geniş pişirici yüzeyiyle kalabalık ailelerin favorisi. 180 derece açılma özelliği ile ızgara olarak kullanabilir, sevdiklerinize lezzet dolu yemekler hazırlayabilirsiniz. Izgaradan çıkan yağlar yağ toplama haznesine akar. 5 kademeli sıcaklık ayarı ve çift yönlü plaka kullanımı ile tam kontrol sizde!", 
      price: "7.699,00 ₺'den başlayan fiyatlarla",
      features: [
        '2400 W güç',
        '6 dilim kapasitesi',
        'Aşınmaya karşı 7 kata kadar daha dayanıklı Quantech plakalar',
        '5 kademeli sıcaklık ayarı',
        'Çift yönlü plaka kullanımı',
        '180° açılma ile ızgara olarak kullanım',
        'Yağ toplama haznesi',
      ],
      dimensions: 'G: 39 cm, D: 33 cm, Y: 13 cm',
      warranty: '3 Yıl Garanti',
    },
    'RHB2410': {
      name: 'RHB 2410 El Blender',
      image: '../files/RHB2410.webp',
      description: "1500 W gücüyle mutfakta en zorlu işleri bile kolayca halledin! RHB 2410 El Blender, doğrayıcı ve doğrayıcı kabı ile pratik kullanım sunar. Güçlü motoru sayesinde pürüzsüz karışımlar, hızlı doğrama ve kolay temizlik bir arada. Sağlam yapısı ve ergonomik tasarımı ile mutfağınızın vazgeçilmezi olacak. Doğrayıcı kabı sayesinde sebze, meyve ve kuruyemişleri saniyeler içinde doğrayabilirsiniz.",
      price: "2.499,00 ₺'den başlayan fiyatlarla",
      features: [
        '1500 W güç',
        'Doğrayıcı aparatı',
        'Doğrayıcı kabı',
        'Ergonomik tasarım',
        'Kolay temizlik',
      ],
      dimensions: 'G: 24 cm, D: 19 cm, Y: 40 cm',
      warranty: '3 Yıl Garanti',
    },
  }

  return (
    <div className="beko-beyaz-esya">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/beko-logo.png" alt="Beko Beyaz Eşya Logo" />
            </div>
            <h1>Beko Beyaz Eşya Koleksiyonu</h1>
            <p>Modern teknoloji ve enerji tasarruflu beyaz eşya çözümleri</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Ürün Kategorilerimiz</h2>
            
            {/* Buzdolabı */}
            <div className="category-section" id="buzdolabi">
              <h3 className="category-title">❄️ Buzdolabı</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/970477MB.webp" alt="Beko Buzdolabı 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('970477MB')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>970477 MB No Frost Buzdolabı</h4>
                    <p>Ezberleri bozan AeroFlow Soğutma Teknolojisi ve kapı yönü esnekliği</p>
                    <div className="product-features">
                      <span className="feature">✓ AeroFlow Soğutma Teknolojisi</span>
                      <span className="feature">✓ %30'a kadar daha uzun tazelik</span>
                      <span className="feature">✓ Kapı yönü esnekliği (sağ/sol)</span>
                    </div>
                    <div className="product-price">
                      <span className="price">31.499,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/670475MB.jpg" alt="Beko Buzdolabı 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('670475MB')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>670475 MB No Frost Buzdolabı</h4>
                    <p>AeroFlow Soğutma Teknolojisi ile dolabın tamamına eşit hava dağılımı</p>
                    <div className="product-features">
                      <span className="feature">✓ %30 daha uzun tazelik</span>
                      <span className="feature">✓ Akıllı sensörler ile optimal soğutma</span>
                      <span className="feature">✓ Antibakteriyel iç yüzey</span>
                    </div>
                    <div className="product-price">
                      <span className="price">35.999,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/678550EIFit.webp" alt="Beko Buzdolabı 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('678550EI-Fit')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>678550 EI ElegantFit No Frost Buzdolabı</h4>
                    <p>ElegantFit ve HarvestFresh™ teknolojisi</p>
                    <div className="product-features">
                      <span className="feature">✓ ElegantFit Teknolojisi (fit yerleşim)</span>
                      <span className="feature">✓ HarvestFresh™ 3 ışık teknolojisi</span>
                      <span className="feature">✓ Vitamin koruma ve tazelik</span>
                    </div>
                    <div className="product-price">
                      <span className="price">60.269,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Çamaşır Makinesi */}
            <div className="category-section" id="camasir-makinesi">
              <h3 className="category-title">👕 Çamaşır Makinesi</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/Cmx10120.webp" alt="Beko Çamaşır Makinesi 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('Cmx10120')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>CMX 10120 Çamaşır Makinesi</h4>
                    <p>10 kg kapasite, unutulan çamaşır ekleme ve daha fazlası</p>
                    <div className="product-features">
                      <span className="feature">✓ 10 kg kapasite</span>
                      <span className="feature">✓ Kazan Temizleme Teknolojisi</span>
                      <span className="feature">✓ Sessiz ve verimli çalışma</span>
                    </div>
                    <div className="product-price">
                      <span className="price">32.249,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/Cmxt9120.webp" alt="Beko Çamaşır Makinesi 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('Cmxt9120')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>CMXT 9120 Çamaşır Makinesi</h4>
                    <p>Prosmart Inverter motor ile sessiz ve verimli temizlik</p>
                    <div className="product-features">
                      <span className="feature">✓ 9 kg kapasite</span>
                      <span className="feature">✓ Unutulan çamaşır ekleme</span>
                      <span className="feature">✓ Kazan Temizleme Teknolojisi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">26.399,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/Cmxd9100.webp" alt="Beko Çamaşır Makinesi 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('Cmxd9100')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>CMXD 9100 Çamaşır Makinesi</h4>
                    <p>Kazan temizleme teknolojisi ile hijyenik ve ferah çamaşırlar!</p>
                    <div className="product-features">
                      <span className="feature">✓ 9 kg kapasite</span>
                      <span className="feature">✓ Tam açılabilen kapak</span>
                      <span className="feature">✓ Buharlı havalandırma teknolojisi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">30.299,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bulaşık Makinesi */}
            <div className="category-section" id="bulasik-makinesi">
              <h3 className="category-title">🍽️ Bulaşık Makinesi</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BM6146.webp" alt="Beko Bulaşık Makinesi 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BM6146')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BM 6146 Bulaşık Makinesi</h4>
                    <p>HijyenMax ve ekstra buhar ile bulaşıklarınızda üstün temizlik</p>
                    <div className="product-features">
                      <span className="feature">✓ 6 program</span>
                      <span className="feature">✓ Otomatik kapı açma</span>
                      <span className="feature">✓ HijyenMax teknolojisi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">23.129,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BM4144WF.webp" alt="Beko Bulaşık Makinesi 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BM4144WF')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BM 4144 WF Bulaşık Makinesi</h4>
                    <p>HomeWhiz Wi-Fi, 4+3 program, HijyenMax ile üstün temizlik</p>
                    <div className="product-features">
                      <span className="feature">✓ 4 program</span>
                      <span className="feature">✓ HomeWhiz Wi-Fi teknolojisi</span>
                      <span className="feature">✓ Ekstra kurutma ve buhar</span>
                    </div>
                    <div className="product-price">
                      <span className="price">22.859,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BM4144OKI.webp" alt="Beko Bulaşık Makinesi 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BM4144OKI')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BM 4144 OK I Bulaşık Makinesi</h4>
                    <p>Otomatik kapı açma ve HijyenMax ile bulaşıklarınızda üstün temizlik</p>
                    <div className="product-features">
                      <span className="feature">✓ 4 program</span>
                      <span className="feature">✓ HijyenMax teknolojisi</span>
                      <span className="feature">✓ Doğal hava akışı ile kurutma</span>
                    </div>
                    <div className="product-price">
                      <span className="price">25.019,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Kurutma Makinesi */}
            <div className="category-section" id="kurutma-makinesi">
              <h3 className="category-title">🌪️ Kurutma Makinesi</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/KMX91.webp" alt="Beko Kurutma Makinesi 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('KMX91')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>KMX 91 Kurutma Makinesi</h4>
                    <p>Isı pompalı kurutma, akıllı nem sensörü ve koku giderici program</p>
                    <div className="product-features">
                      <span className="feature">✓ 9 kg kapasite</span>
                      <span className="feature">✓ Isı pompalı kurutma teknolojisi</span>
                      <span className="feature">✓ Akıllı nem sensörü</span>
                    </div>
                    <div className="product-price">
                      <span className="price">30.869,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/KMB901I.webp" alt="Beko Kurutma Makinesi 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('KMB901I')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>KMB 901 I Kurutma Makinesi</h4>
                    <p>Akıllı nem sensörü, ısı pompalı kurutma ve 3 farklı koku seçeneği</p>
                    <div className="product-features">
                      <span className="feature">✓ 9 kg kapasite</span>
                      <span className="feature">✓ Akıllı nem sensörü</span>
                      <span className="feature">✓ Enerji tasarrufu</span>
                    </div>
                    <div className="product-price">
                      <span className="price">33.179,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/KMX1001.webp" alt="Beko Kurutma Makinesi 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('KMX1001')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>KMX 1001 Kurutma Makinesi</h4>
                    <p>10 kg kapasite, akıllı nem sensörü ile en havalı ve taze kıyafetler</p>
                    <div className="product-features">
                      <span className="feature">✓ 10 kg kapasite</span>
                      <span className="feature">✓ Isı pompalı kurutma teknolojisi</span>
                      <span className="feature">✓ Koku giderici program</span>
                    </div>
                    <div className="product-price">
                      <span className="price">33.509,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Televizyon */}
            <div className="category-section" id="televizyon">
              <h3 className="category-title">📺 Televizyon</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/B50E795B.webp" alt="Beko Televizyon 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('B50E795B')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Crystal 7 50" 4K UHD Google TV - B50 E 795 B Smart TV</h4>
                    <p>Chromecast ve parlak piksel garantisi ile kusursuz seyir keyfi</p>
                    <div className="product-features">
                      <span className="feature">✓ 4K Ultra HD</span>
                      <span className="feature">✓ Parlak piksel garantisi</span>
                      <span className="feature">✓ Kolay mobil kontrol</span>
                    </div>
                    <div className="product-price">
                      <span className="price">28.999,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/B55E795B.webp" alt="Beko Televizyon 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('B55E795B')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Crystal 7 55" 4K UHD Google TV - B55 E 795 B LED TV</h4>
                    <p>Google TV, 4K UHD ve parlak piksel garantisi ile mükemmel seyir keyfi</p>
                    <div className="product-features">
                      <span className="feature">✓ 4K Ultra HD</span>
                      <span className="feature">✓ HDR10+ ve Dolby Vision</span>
                      <span className="feature">✓ Parlak piksel garantisi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">31.999,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/B65E795B.webp" alt="Beko Televizyon 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('B65E795B')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Crystal 7 65" 4K UHD Google TV - B65 E 795 B LED TV</h4>
                    <p>4K UHD, HDR10+, parlak piksel garantisi ile harika seyir keyfi!</p>
                    <div className="product-features">
                      <span className="feature">✓ 4K Ultra HD</span>
                      <span className="feature">✓ Parlak piksel garantisi</span>
                      <span className="feature">✓ Kolay mobil kontrol</span>
                    </div>
                    <div className="product-price">
                      <span className="price">43.999,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Ankastre */}
            <div className="category-section" id="ankastre">
              <h3 className="category-title">🔥 Ankastre</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BOCDT6510EG.webp" alt="Beko Ankastre 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BOCDT6510EG')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BOCD T 6510 EG Beyond Serisi Gazlı Cam Tablalı Ocak</h4>
                    <p>PractiClean nano kaplama, XL ankastre ocak ve %63 daha verimli ocak gözleri</p>
                    <div className="product-features">
                      <span className="feature">✓ PractiClean Nano Kaplama</span>
                      <span className="feature">✓ XL ankastre ocak (4 yemek aynı anda)</span>
                      <span className="feature">✓ Kolay temizlik ve parlaklık</span>
                    </div>
                    <div className="product-price">
                      <span className="price">12.780,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BFC432G.webp" alt="Beko Ankastre 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BFC432G')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BFC 432 G FitFry Fırın</h4>
                    <p>FitFry, buhar destekli, 3D pişirme ve katalitik temizleme ile her pişirmede kusursuz sonuç ve kolay temizlik</p>
                    <div className="product-features">
                      <span className="feature">✓ FitFry Teknolojisi</span>
                      <span className="feature">✓ Buhar destekli pişirme</span>
                      <span className="feature">✓ 3D Pişirme teknolojisi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">21.989,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/BDE6062G.webp" alt="Beko Ankastre 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('BDE6062G')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>BDE 6062 G Duvar Tipi Davlumbaz</h4>
                    <p>Yüksek emiş gücü, otomatik mod ve hava temizleme fonksiyonu</p>
                    <div className="product-features">
                      <span className="feature">✓ Yüksek emiş gücü</span>
                      <span className="feature">✓ Düşük ses seviyesi</span>
                      <span className="feature">✓ Otomatik mod</span>
                    </div>
                    <div className="product-price">
                      <span className="price">13.990,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Klima */}
            <div className="category-section " id="klima">
              <h3 className="category-title">❄️ Klima</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/31225A.png" alt="Beko Klima 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('31225A')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>31225 A Ekolojik Inverter Klima 12.000 Btu/h Split Klima</h4>
                    <p>12000 Btu/h soğutma kapasitesi, kolay çıkarılabilir filtre ve yumuşak hava modu</p>
                    <div className="product-features">
                      <span className="feature">✓ 12000 Btu/h soğutma kapasitesi</span>
                      <span className="feature">✓ Yumuşak hava modu</span>
                      <span className="feature">✓ Özel filtreler</span>
                    </div>
                    <div className="product-price">
                      <span className="price">32.655,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/31225A.png" alt="Beko Klima 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('31825')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>31825 Ekolojik Inverter Klima 18.000 Btu/h Split Klima</h4>
                    <p>18000 Btu/h soğutma kapasitesi, kolay çıkarılabilir filtre ve yumuşak hava modu</p>
                    <div className="product-features">
                      <span className="feature">✓ 18000 Btu/h soğutma kapasitesi</span>
                      <span className="feature">✓ Kolay çıkarılabilir filtre</span>
                      <span className="feature">✓ Yumuşak hava modu</span>
                    </div>
                    <div className="product-price">
                      <span className="price">45.261,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/31225A.png" alt="Beko Klima 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('32425')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>32425 Ekolojik Inverter Klima 24.000 Btu/h Split Klima</h4>
                    <p>24000 Btu/h soğutma kapasitesi, kolay çıkarılabilir filtre ve yumuşak hava modu</p>
                    <div className="product-features">
                      <span className="feature">✓ 12000 Btu/h soğutma kapasitesi</span>
                      <span className="feature">✓ Yumuşak hava modu</span>
                      <span className="feature">✓ Özel filtreler</span>
                    </div>
                    <div className="product-price">
                      <span className="price">53.802,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Küçük Ev Aletleri */}
            <div className="category-section" id="kucuk-ev-aletleri">
              <h3 className="category-title">🏠 Küçük Ev Aletleri</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/CM5964.webp" alt="Beko Küçük Ev Aleti 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('CM5964')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>CM 5964 Floral Çay Makinesi</h4>
                    <p>0.8 L cam demlik, 2 L cam su haznesi ve mavi/kırmızı ışık göstergesi</p>
                    <div className="product-features">
                      <span className="feature">✓ 0.8 L demlik kapasitesi</span>
                      <span className="feature">✓ Kırılmaya 4 kata kadar dayanıklı cam</span>
                      <span className="feature">✓ 2 L su ısıtıcı kapasitesi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">5.499,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/TM5046C.webp" alt="Beko Küçük Ev Aleti 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('TM5046C')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>TM 5046 C Floral Tost Makinesi</h4>
                    <p>2400 W güç, 6 dilim kapasitesi, Quantech plakalar ve ızgara fonksiyonu</p>
                    <div className="product-features">
                      <span className="feature">✓ 6 dilim kapasitesi</span>
                      <span className="feature">✓ 7 kata kadar daha dayanıklı plakalar</span>
                      <span className="feature">✓ Yağ toplama haznesi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">7.699,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/RHB2410.webp" alt="Beko Küçük Ev Aleti 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('RHB2410')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>RHB 2410 El Blender</h4>
                    <p>1500 W güç, doğrayıcı ve doğrayıcı kabı ile mutfağınızda pratik ve hızlı kullanım</p>
                    <div className="product-features">
                      <span className="feature">✓ Doğrayıcı aparatı</span>
                      <span className="feature">✓ Ergonomik tasarım</span>
                      <span className="feature">✓ Kolay temizlik</span>
                    </div>
                    <div className="product-price">
                      <span className="price">2.499,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Beko Beyaz Eşya Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <h3>Enerji Tasarrufu</h3>
                <p>Yüksek enerji sınıfı ile düşük tüketim</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔧</div>
                <h3>Kolay Bakım</h3>
                <p>Pratik temizlik ve bakım özellikleri</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Uzun Garanti</h3>
                <p>Kapsamlı garanti ve servis desteği</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏠</div>
                <h3>Ev Dostu Teknoloji</h3>
                <p>Aileler için tasarlanmış akıllı özellikler</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Beko Beyaz Eşya ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Product Detail Modal */}
      {isDetailOpen && selectedProduct && products[selectedProduct] && (
        <div className="product-detail-modal">
          <div className="modal-overlay" onClick={closeDetail}></div>
          <div className="modal-content">
            <button className="close-button" onClick={closeDetail}>
              <FaTimes />
            </button>
            
            <div className="modal-body">
              <div className="product-image-section">
                <img 
                  src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                  alt={products[selectedProduct]?.name || 'Ürün'}
                  className="detail-image"
                />
              </div>
              
              <div className="product-info-section">
                <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                
                <div className="product-details">
                  <h3>Özellikler</h3>
                  <ul className="features-list">
                    {(products[selectedProduct]?.features || []).map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  
                  <div className="specifications">
                    <h3>Teknik Özellikler</h3>
                    <div className="spec-item">
                      <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item price">
                      <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                    </div>
                  </div>
                  
                  <div className="action-buttons">
                    <a href="tel:+905496250335" className="btn btn-primary">
                      📞 Fiyat Bilgisi Al
                    </a>
                    <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BekoBeyazEsya;
